const Download = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5080"
            data-name="Rectangle 5080"
            width="10"
            height="10"
            transform="translate(0 0)"
            fill="#fff"
            stroke="#fff"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g id="Group_18072" transform="translate(-159 -952)">
        <g id="Mask_Group_572" data-name="Mask Group 572" transform="translate(159 960)">
          <g id="next_1_" transform="translate(9.345 2.855) rotate(90)">
            <g id="Group_18071" transform="translate(0 0)">
              <path
                id="Path_59445"
                d="M4.553,4.07.57.1A.334.334,0,1,0,.1.57L3.845,4.306.1,8.042a.334.334,0,0,0,.472.473L4.553,4.543a.334.334,0,0,0,0-.473Z"
                transform="translate(0 0)"
                fill="#fff"
                stroke="#fff"
                strokeWidth="1"
              />
            </g>
          </g>
        </g>
        <rect
          id="Rectangle_5081"
          width="1.5"
          height="11"
          rx="0.75"
          transform="translate(163 952)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default Download;
